var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[(_vm.link !== null)?_c('a',{attrs:{"href":_vm.link}},[_c('img',{attrs:{"src":_vm.image,"alt":"Logo"}})]):_c('img',{attrs:{"src":_vm.image,"alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }